import i18n from '@/localisation/i18n';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { deleteProfile } from '../api/deleteProfile';
import { SimpleDialog } from '@/widgets/SimpleDialog';
import { AxiosError } from 'axios';
import { removeCookies } from '@/utils/cookie';

export const DeleteButton = () => {
  const [showDialog, setShowDialog] = useState(false);

  const { mutate } = useMutation({
    mutationFn: () => deleteProfile(),
    onSuccess: () => {
      removeCookies('auth');
      setShowDialog(false);
    },
    onError: (error: AxiosError) => {
      if (error.response?.status === 401) {
        window.location.href = '/auth';
      }
    },
  });

  return (
    <>
      <button
        onClick={() => setShowDialog(true)}
        className="btn btn-link btn-error mt-auto p-0 font-normal text-error no-underline"
      >
        {i18n.t('delete.account')}
      </button>
      <SimpleDialog
        title={i18n.t('delete.profile')}
        subtitle={i18n.t('delete.profile.subtitle')}
        actionButtonText={i18n.t('delete')}
        actionButtonClick={mutate}
        closeDialog={() => setShowDialog(false)}
        showDialog={showDialog}
      />
    </>
  );
};
